module.exports = __webpack_public_path__ + "img/round4.b8925372.png";